<div class="app">
  <app-navbar></app-navbar>
  @if (title.startsWith('admin')) {
  <div style="height: 5em;"></div>
  }
  <div class="site-blocks-cover overlay d-none d-md-block" [class.inner-page-cover]="title != 'Welcome'"
    [class.admin-page-cover]="title.startsWith('admin')"
    style="background-image: url('../assets/images/blackwhitewide.jpg')" data-aos="fade"
    data-stellar-background-ratio="0.5">
    <div class="container">
      <div class="row align-items-center justify-content-center">
        <div class="col-md-7 text-center text-white" data-aos="fade-up" data-aos-delay="400">
          <h1 class="mb-4 pagetitle">{{ title }}</h1>
        </div>
      </div>
    </div>
  </div>

  <div class="site-blocks-cover overlay d-block d-md-none" [class.inner-page-cover]="title != 'Welcome'"
    style="background-image: url('../assets/images/blackwhitewide.jpg')">
    <div class="container">
      <div class="row align-items-center justify-content-center">
        <div class="col-md-7 text-center text-white" data-aos="fade-up" data-aos-delay="400">
          @if (title == 'Welcome') {
          <h1 class="mb-4 pagetitle">Set Me Free - Out Now!</h1>
          <div class="mt-4 ratio ratio-16x9">
            <iframe src="https://youtu.be/l4TeawpJcc0" title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          }
          @else {
          <h1 class="mb-4 pagetitle">{{title}}</h1>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="invisible">
    Argon is an alternative rock band based in Landen, Belgium.
  </div>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>